import React from 'react';
import { LayoutSwitcher } from 'partials/MainLayout';
import { withTranslation } from 'react-i18next';
import * as _ from 'lib/utilities';
import BodyMeasurements from 'partials/BodyMeasurements';
import { ExerciseChartsTab } from 'partials/ProgressCharts';
import ActivityContainer, { CenteredActivityContainer } from 'components/ActivityContainer';
import { strengthBodyStatsPath } from 'config/paths';

const Core = ({ activeTab, isInternal, t }) => {
    const tabIndex = _.isBlank(activeTab) ? 1 : activeTab;

    return (
        <React.Fragment>
                {!isInternal && (<ActivityContainer>
                    <div className="text-center ml10 mr10 mb0">
                        <h1 style={{fontSize: '2rem'}}>{t('body measurements header')}</h1>
                    </div>
                </ActivityContainer>)}
                {tabIndex === 1 && <BodyMeasurements />}
                {tabIndex === 2 && (
                <CenteredActivityContainer>
                    <ExerciseChartsTab basePath={strengthBodyStatsPath} isTab />
                </CenteredActivityContainer>
                )}
        </React.Fragment>
    )
}

class StrengthAndBodyStatsPage extends React.Component {


    render() {
        const { t, isInternal } = this.props;
        const tabLabels = [t('Body'),t('Strength')];

        return (
            <LayoutSwitcher {...this.props} title={`${t('Strength')}/${t('Body Stats')}`} tabLabels={tabLabels}>
                <Core isInternal={isInternal} t={t} />
            </LayoutSwitcher>
        )
    }
}

export default withTranslation()(StrengthAndBodyStatsPage);
